"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlightInformationPortalPurpose = exports.FlightInformationFileSource = exports.FlightInformationFileRole = exports.FlightInformationDataSource = exports.FlightInformationStatus = exports.FlightInformationMode = void 0;
var FlightInformationMode;
(function (FlightInformationMode) {
    FlightInformationMode["PATIENT_PROVIDES"] = "patient_provides";
    FlightInformationMode["JEMA_BOOKS"] = "jema_books";
    FlightInformationMode["SKIPPED"] = "skipped";
})(FlightInformationMode || (exports.FlightInformationMode = FlightInformationMode = {}));
var FlightInformationStatus;
(function (FlightInformationStatus) {
    FlightInformationStatus["NOT_SENT"] = "not_sent";
    FlightInformationStatus["REQUESTED"] = "requested";
    FlightInformationStatus["RECEIVED"] = "received";
    FlightInformationStatus["JEMA_BOOKED"] = "jema_booked";
    FlightInformationStatus["SKIPPED"] = "skipped";
})(FlightInformationStatus || (exports.FlightInformationStatus = FlightInformationStatus = {}));
var FlightInformationDataSource;
(function (FlightInformationDataSource) {
    FlightInformationDataSource["PATIENT"] = "patient";
    FlightInformationDataSource["ADMIN"] = "admin";
    FlightInformationDataSource["LOOKUP"] = "lookup";
})(FlightInformationDataSource || (exports.FlightInformationDataSource = FlightInformationDataSource = {}));
var FlightInformationFileRole;
(function (FlightInformationFileRole) {
    FlightInformationFileRole["TICKET"] = "ticket";
    FlightInformationFileRole["SUPPORTING"] = "supporting";
})(FlightInformationFileRole || (exports.FlightInformationFileRole = FlightInformationFileRole = {}));
var FlightInformationFileSource;
(function (FlightInformationFileSource) {
    FlightInformationFileSource["PATIENT"] = "patient";
    FlightInformationFileSource["ADMIN"] = "admin";
})(FlightInformationFileSource || (exports.FlightInformationFileSource = FlightInformationFileSource = {}));
var FlightInformationPortalPurpose;
(function (FlightInformationPortalPurpose) {
    FlightInformationPortalPurpose["SUBMIT_DETAILS"] = "submit_details";
    FlightInformationPortalPurpose["TICKET_DELIVERY"] = "ticket_delivery";
})(FlightInformationPortalPurpose || (exports.FlightInformationPortalPurpose = FlightInformationPortalPurpose = {}));
//# sourceMappingURL=flight-information.types.js.map